// extracted by mini-css-extract-plugin
export default {"CreateOfferStepsOverview":"OfferStepsOverview_CreateOfferStepsOverview__UvGMp"};